import React, { Component } from 'react';
import css from "./Login.module.scss";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import ErrorLabel from '../../components/ErrorLabel/ErrorLabel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLock, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";
import axios from 'axios';
import {connect} from "react-redux";
import {setUser} from '../../store/actions';
import { EMAIL_REGEX } from '../../constants';


/**
 * @class
 */
const Login = class extends Component {
    // ---------- class fields: ----------
    source = axios.CancelToken.source();

    // ---------- state: ----------
    state = {
        isPasswordVisible: false, // whether password input field is shown
        pwIcon: faEye,
        invalidLogin: false,
        invalidLoginMessage: 'Invalid Email And/Or Password'
    };

    handlePwClick () {

        if(this.state.pwIcon === faEye){
            this.setState({
                pwIcon: faEyeSlash
            });
        } else {
            this.setState({
                pwIcon: faEye
            });
        }

        this.setState({
            isPasswordVisible: !this.state.isPasswordVisible
        });
    }

    // ---------- life cycle methods: ----------
    componentWillUnmount() {
        this.source.cancel();
    }

    render() {
        return (
            <div className="App App--Login">
                <div className={css.Login}>
                    <img className={css.Login__Logo} src="/assets/logo-V3.png" alt="V3 logo" />
                    <Formik
                        initialValues={{
                            email: '',
                            password: '',
                        }}

                        validate={
                            (values)=> {
                                const errors = {};

                                if (!values.email.trim()) {
                                    errors.email = 'Please Enter An Email Address';
                                } else if (!EMAIL_REGEX.test(values.email)) {
                                    errors.email = 'Invalid Email Address';
                                }

                                // n.b. correct email+password combination is validated server-side
                                if (!values.password.trim()) {
                                    errors.password = 'Please Enter Your Password';
                                }

                                return errors;
                            }
                        }

                        onSubmit={
                            // Handler for when user clicks "Sign In" in the Login page.
                            // N.b. payload only includes user data; doesn't include meta data like headers, xsrfCookieName, etc.
                            (values) => {

                                // n.b. fields are validated before `onSubmit` fires
                                axios.post(
                                    '/auth/local',
                                    {identifier: values.email, password: values.password},
                                    {
                                        cancelToken: this.source.token
                                    })
                                    .then( (res) => {
                                        this.props.dispatch(setUser({
                                            user: res.data,
                                            isLoggedIn: true
                                        }));

                                        // redirect to default route:
                                        if(this.props.user.role === 'partner'){
                                            this.props.history.push('/customers');
                                        } else if (this.props.user.role === 'field'){
                                            this.props.history.push('/workOrders');
                                        } else {
                                            this.props.history.push('/scoreboard');
                                        }
                                    })
                                    .catch(
                                        (err) => {
                                        console.log('(POST) Error in Login:\n', err)
                                        this.setState({
                                            invalidLogin: true
                                        })
                                    });
                            }
                        }
                    >
                        <Form className={css.Login__Form}>

                            {
                                this.state.invalidLogin ?
                                (
                                    <div>
                                        <div className={css.Login__error}>Invalid Email And/Or Password</div>
                                        <h2></h2>
                                    </div>
                                )
                                :
                                (
                                    <div></div>
                                )
                            }

                            <div>
                                <div className="input-with-icons-container">
                                    <FontAwesomeIcon icon={faEnvelope} />
                                    <Field className="input" type="text" name="email" placeholder="Email" />
                                </div>
                                <ErrorMessage name="email" component={ErrorLabel} />
                            </div>

                            <div className="mt-3">
                                <div className={css.Login__PasswordField}>
                                    <FontAwesomeIcon icon={this.state.pwIcon} onClick={() => this.handlePwClick()} />
                                    <FontAwesomeIcon icon={faLock} />
                                    <Field className="input" type={this.state.isPasswordVisible ? "text" : "password" } name="password" placeholder="Password" />
                                </div>
                                <ErrorMessage name="password" component={ErrorLabel} />
                            </div>

                            <div className="mt-5 d-flex flex-no-wrap align-items-center justify-content-between">
                                <Link to="/login/password_recovery" className="link-underline">Forgot</Link>
                                <Link to="/login/create_login" className="link-underline">Sign Up</Link>
                                <button className={css.Login__BtnSubmit} type="submit">Sign In</button>
                            </div>
                        </Form>
                    </Formik>
                </div>
            </div>
        );
    }
};


// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user,
        isLoggedIn: state.isLoggedIn
    };
};

export default connect(mapStateToProps)(Login);
